<template>
  <b-container fluid class="gradient">
    <b-row align-h="center" class="full-height">
      <b-col md="6" lg="4" align-self="center">
        <b-card>
          <div class="text-center">
            <img class="logo" src="/img/new-logo.svg" />
          </div>
          <h2 class="text-sm-center">Reset your password</h2>
          <p class="card-text text-sm-center">Set your new credentials</p>

          <b-form class="form">
            <b-alert variant="danger" class="text-center" :show="resetPasswordError">
              Couldn't reset password
            </b-alert>

            <b-form-group :invalid-feedback="emailError" :state="hasEmailError">
              <b-input-group>
                <b-input-group-text slot="prepend">
                  <font-awesome-icon icon="at" />
                </b-input-group-text>
                <b-form-input
                  name="email"
                  v-focus
                  size="lg"
                  required
                  v-validate="'required|email'"
                  data-vv-validate-on="change|blur"
                  :state="hasEmailError"
                  v-model.trim="form.email"
                  placeholder="Email"
                  @keyup.native.enter="resetPassword"
                  type="text"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group :invalid-feedback="passwordError" :state="hasPasswordError">
              <b-input-group>
                <b-input-group-text slot="prepend">
                  <font-awesome-icon icon="lock" />
                </b-input-group-text>
                <b-form-input
                  size="lg"
                  name="newpassword"
                  ref="password"
                  required
                  v-validate="'required|min:6'"
                  data-vv-validate-on="change|blur"
                  v-model.trim="form.newpassword"
                  :state="hasPasswordError"
                  placeholder="Password"
                  @keyup.native.enter="resetPassword"
                  type="password"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group :invalid-feedback="confirmError" :state="hasConfirmError">
              <b-input-group>
                <b-input-group-text slot="prepend">
                  <font-awesome-icon icon="check-double" />
                </b-input-group-text>
                <b-form-input
                  size="lg"
                  name="confirm"
                  required
                  v-validate="'required|confirmed:password'"
                  data-vv-validate-on="change"
                  v-model.trim="form.confirm"
                  :state="hasConfirmError"
                  placeholder="Confirm password"
                  @keyup.native.enter="resetPassword"
                  type="password"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group>
              <b-button size="lg" block variant="primary" @click="resetPassword" :disabled="hasErrors">
                <strong>Reset</strong>
              </b-button>
            </b-form-group>
          </b-form>

          <b-row slot="footer">
            <b-col class="text-center">
              <router-link :to="{ name: 'login' }">Login</router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script type="text/javascript">
const DEFAULT = {
  email: '',
  newpassword: '',
  confirm: ''
}

export default {
  props: {
    resetKey: { type: String, required: true }
  },
  data: () => ({
    form: { ...DEFAULT },
    resetPasswordError: false
  }),
  computed: {
    hasEmailError() {
      return this.fieldBag.email && this.fieldBag.email.dirty ? this.fieldBag.email.valid : null
    },
    emailError() {
      return this.errors.has('email') ? this.errors.first('email') : ''
    },
    hasPasswordError() {
      return this.fieldBag.newpassword && this.fieldBag.newpassword.dirty ? this.fieldBag.newpassword.valid : null
    },
    passwordError() {
      return this.errors.has('newpassword') ? this.errors.first('newpassword') : ''
    },
    hasConfirmError() {
      return this.fieldBag.confirm && this.fieldBag.confirm.dirty ? this.fieldBag.confirm.valid : null
    },
    confirmError() {
      return this.errors.has('confirm') ? this.errors.first('confirm') : ''
    },
    hasErrors() {
      return this.errors.any()
    }
  },
  methods: {
    resetPassword() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let creds = {
            email: this.form.email,
            newpassword: this.form.newpassword,
            resetkey: this.resetKey
          }
          this.$emit('reset-request', creds)
          this.$store
            .dispatch('resetPassword', creds)
            .then(() => {
              this.$router.push({ name: 'login' })
            })
            .catch(() => {
              this.resetPasswordError = true
            })
        }
      })
    }
  }
}
</script>
